module.exports = __webpack_public_path__ + "img/gntech_gallery2.affc749e.jpg";